import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/changeMobile',
    name: 'changeMobile',
    meta: {
      title: '验证信息',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/changeMobile/index.vue'),
  },
  {
    path: '/changeMobile/faceCallBack',
    name: 'changeMobileFaceCallBack',
    meta: {
      title: '',
      isApp: true,
      auth: false,
    },
    component: () => import('@/views/changeMobile/faceCallBack.vue'),
  },
]

export default routes
